import React from "react";
import { Box, Typography, useTheme } from "@mui/material";
import { CheckCategory } from "../../../utils/enums";
import PeopleEvidenceTab from "./PeopleEvidence/PeopleEvidenceTab";
import AWSEvidenceTab from "./InfraEvidence/AWSEvidenceTab";
import AzureEvidenceTab from "./InfraEvidence/AzureEvidenceTab";
import GCPEvidenceTab from "./InfraEvidence/GCPEvidenceTab";
import GenericEvidenceTab from "./GenericEvidence/GenericEvidenceTab";
import PolicyEvidenceTab from "./PolicyEvidence/PolicyEvidenceTab";
import PassWithEvidenceTab from "./PassWithEvidence/PassWithEvidenceTab";

const EvidenceResourcesTab = ({
  checkDetails,
  activeCheckId,
  checkCategory,
  onRefetch,
  onRegisterRefetch,
  isAuditorView = false,
  auditEndDate,
  defaultStatusFilter = [],
}) => {
  const theme = useTheme();
  const checkCategoryLower = checkDetails?.active_check_category?.toLowerCase() || "";

  const isPassWithEvidence = checkCategoryLower.includes(CheckCategory?.PASS_WITH_EVIDENCE);
  const isPeopleCheck = checkCategoryLower.includes(CheckCategory?.PEOPLE_CHECK);
  const isPolicyCheck = checkCategoryLower.includes(CheckCategory?.POLICY_CHECK) ||
                        checkCategoryLower.includes(CheckCategory?.POLICY_CONTENT_CHECK);
  const isAWS = checkCategory === CheckCategory?.AWS_SYSTEM_CHECK;
  const isAzure = checkCategory === CheckCategory?.AZURE_SYSTEM_CHECK;
  const isGCP = checkCategory === CheckCategory?.GCP_SYSTEM_CHECK;

  const hasResources = checkDetails?.resources && checkDetails.resources.length > 0;
  const showGenericResources = hasResources && !isPeopleCheck && !isPolicyCheck && !isAWS && !isAzure && !isGCP;

  if (isPassWithEvidence) {
    return (
      <PassWithEvidenceTab
        checkDetails={checkDetails}
        activeCheckId={activeCheckId}
        onRefetch={onRefetch}
        auditEndDate={auditEndDate}
      />
    );
  }

  if (isPeopleCheck && isPolicyCheck) {
    return (
      <PeopleEvidenceTab
        checkDetails={checkDetails}
        activeCheckId={activeCheckId}
        onRefetch={onRefetch}
        isAuditorView={isAuditorView}
        showPolicyButton={true}
        defaultStatusFilter={defaultStatusFilter}
      />
    );
  }

  if (isPolicyCheck) {
    return (
      <PolicyEvidenceTab
        checkDetails={checkDetails}
        isAuditorView={isAuditorView}
      />
    );
  }

  if (isPeopleCheck) {
    return (
      <PeopleEvidenceTab
        checkDetails={checkDetails}
        activeCheckId={activeCheckId}
        onRefetch={onRefetch}
        isAuditorView={isAuditorView}
        defaultStatusFilter={defaultStatusFilter}
      />
    );
  }

  if (isAWS) {
    return (
      <AWSEvidenceTab
        checkDetails={checkDetails}
        checkCategory={checkCategory}
        defaultStatusFilter={defaultStatusFilter}
      />
    );
  }

  if (isAzure) {
    return (
      <AzureEvidenceTab
        checkDetails={checkDetails}
        checkCategory={checkCategory}
        defaultStatusFilter={defaultStatusFilter}
      />
    );
  }

  if (isGCP) {
    return (
      <GCPEvidenceTab
        checkDetails={checkDetails}
        checkCategory={checkCategory}
        defaultStatusFilter={defaultStatusFilter}
      />
    );
  }

  if (showGenericResources) {
    return (
      <GenericEvidenceTab 
        checkDetails={checkDetails}
        activeCheckId={activeCheckId}
        onRefetch={onRefetch}
        isAuditorView={isAuditorView}
        defaultStatusFilter={defaultStatusFilter}
      />
    );
  }

  return (
    <Box
      sx={{
        flex: 1,
        backgroundColor: "#FFFFFF",
        borderRadius: "12px",
        border: `1px solid ${theme.customColors.border.main}`,
        boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        p: 4,
      }}
    >
      <Typography
        sx={{
          fontSize: "15px",
          color: theme.customColors.text.secondary,
          textAlign: "center",
        }}
      >
        No evidence available for this check
      </Typography>
    </Box>
  );
};

export default EvidenceResourcesTab;
